import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './ReduxStore';
import type { IMessageDialogTypes } from '../components/Layout/Dialogs/DialogConfig';

interface IMessageDialogConfig {
    message?: string;
    title: string;
    type: IMessageDialogTypes;
}

export interface IMessageDialogState {
    config: IMessageDialogConfig | null;
}

const initialState: IMessageDialogState = {
    config: null,
};

const reducers = {
    update: (state: IMessageDialogState, action: PayloadAction<IMessageDialogConfig | null>) => {
        state.config = action.payload;
    },
};

export const messageDialogSlice = createSlice({
    name: 'messageDialog',
    initialState,
    reducers,
});

export const messageDialogConfig = (state: IGlobalStoreReducers) => state.messageDialog.config;

export const { update } = messageDialogSlice.actions;

export default messageDialogSlice.reducer;
